import { z } from "zod"

export const TransactionTotalsDtoSchema = z
  .object({
    succeededTransactionsNumber: z.number(),
    pendingTransactionsNumber: z.number(),
    failedTransactionsNumber: z.number(),
    disputedTransactionsNumber: z.number(),
    refundedTransactionsNumber: z.number(),
  })
  .meta({ id: "TransactionTotalsDtoSchema" })

export type TransactionTotalsDto = z.infer<typeof TransactionTotalsDtoSchema>
